 import './Profile.scss';

export const Profile = ({firstName, lastName, showName}) => {
    const initials = `${firstName[0]}${lastName[0]}`;

    return (
        <div className={"profile"}>
            <div className={"profile_container"}>
                <div className={"profile_avatar"}>
                    {initials}
                </div>
                {showName && (
                    <div className={"profile_name"}>
                        {`${firstName} ${lastName}`}
                    </div>
                )}
            </div>
        </div>
    )
}